import * as React from 'react';

import { PrimitiveTabs } from 'components';
import { usePurchaseAction, usePurchaseValue } from 'context';

import { PurchaseBaseInfo } from './base-info';
import { PurchaseRecipientInfo } from './recipient-info';

const PurchaseFormTabs = () => {
  const { step = 1 } = usePurchaseValue();
  const action = usePurchaseAction();

  return (
    <PrimitiveTabs
      items={[
        {
          key: '1',
          label: 'اطلاعات اولیه',
          children: <PurchaseBaseInfo />,
        },
        {
          key: '2',
          label: 'مشخصات گیرنده',
          children: <PurchaseRecipientInfo />,
        },
      ]}
      activeKey={step.toString()}
      onChange={activeKey => {
        action({
          type: 'UPDATE_PURCHASE_STEP',
          payload: {
            step: +activeKey as typeof step,
          },
        });
      }}
    />
  );
};

export { PurchaseFormTabs };
